import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getOrcamentoVsRealizado, upsertOrcamento, OrcamentoInput } from '../services/api';

export const useObraOrcamento = (obraId: string | undefined) => {
    const queryClient = useQueryClient();
    const id = Number(obraId);

    const {
        data: orcamento,
        isLoading: loadingOrcamento,
        error: errorOrcamento,
        refetch: refetchOrcamento
    } = useQuery({
        queryKey: ['orcamento', id],
        queryFn: () => getOrcamentoVsRealizado(id),
        enabled: !!id,
    });

    const updateOrcamentoMutation = useMutation({
        mutationFn: (input: OrcamentoInput) => upsertOrcamento(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['orcamento', id] });
        },
    });

    return {
        orcamento,
        loadingOrcamento,
        errorOrcamento,
        refetchOrcamento,
        updateOrcamento: updateOrcamentoMutation.mutateAsync,
        isUpdating: updateOrcamentoMutation.isPending
    };
};
